import React, { useContext } from 'react';
import { RegistrationStatus } from '@/modules/common/enums';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import { Typography } from '@pw-tech/omni-ui';
import Waiting from './Waiting/Waiting';
import Pass from './Pass/Pass';
import Fail from './Fail/Fail';
const FinalResult = () => {
  const {
    registrationDetails
  } = useContext(RegistrationContext);
  const renderFinalResult = (status: string) => {
    switch (status) {
      case RegistrationStatus.final_result_waiting:
        return <Waiting />;
      case RegistrationStatus.final_result_declared:
        return <Pass />;
      case RegistrationStatus.final_result_not_cleared:
        return <Fail />;
      default:
        return <Typography variant="heading3" weight="semi-bold">
            Invalid Final Result Status
          </Typography>;
    }
  };
  return <>
      <Typography variant="heading3" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        Final Result
      </Typography>
      {renderFinalResult(registrationDetails?.final_result_status ?? '')}
    </>;
};
export default FinalResult;